var _path, _path2, _path3, _rect, _rect2, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgValidatorError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 48,
    viewBox: "0 0 144 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.5088 32.4785H57.6444C59.4393 32.4785 60.8944 33.9336 60.8944 35.7285V37.4912C60.8944 39.2862 59.4393 40.7412 57.6444 40.7412H57.5088C55.7139 40.7412 54.2588 39.2862 54.2588 37.4912V35.7285C54.2588 33.9336 55.7139 32.4785 57.5088 32.4785Z",
    fill: "#475467",
    stroke: "#1D2939",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8135 7.2583H63.3389C65.1338 7.2583 66.5889 8.71337 66.5889 10.5083V30.9829C66.5889 32.7778 65.1338 34.2329 63.3389 34.2329H51.8135C50.0185 34.2329 48.5635 32.7778 48.5635 30.9829V10.5083C48.5635 8.71338 50.0186 7.2583 51.8135 7.2583Z",
    fill: "#F9F9FB",
    stroke: "#1D2939",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2539 11.4394C50.2539 10.1609 51.437 9.21063 52.6854 9.48646L61.6355 11.464C62.4878 11.6523 63.1196 12.3717 63.1963 13.2413L64.7062 30.3668C64.8093 31.5361 63.8878 32.5424 62.7139 32.5424H52.2539C51.1493 32.5424 50.2539 31.647 50.2539 30.5424V11.4394Z",
    fill: "#667085"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 72.2526,
    y: 28.6609,
    width: 4.89835,
    height: 24.0934,
    rx: 2.44917,
    transform: "rotate(-107.369 72.2526 28.6609)",
    fill: "#F9F9FB",
    stroke: "#1D2939",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 74.3779,
    y: 27.7046,
    width: 2.04233,
    height: 20.4233,
    rx: 1.02117,
    transform: "rotate(-107.369 74.3779 27.7046)",
    fill: "#667085"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0893 31.3138L70.0893 20.7842C70.0896 20.7843 70.0899 20.7844 70.0902 20.7844C70.5722 20.8752 71.2048 21.0516 71.8295 21.39C72.4506 21.7264 73.0559 22.218 73.5082 22.9424C73.9588 23.664 74.2842 24.6585 74.2842 26.0444C74.2842 27.4487 73.958 28.4517 73.5076 29.1756C73.0557 29.9019 72.4517 30.3905 71.8326 30.7222C71.2095 31.056 70.5783 31.2264 70.0973 31.3123C70.0946 31.3128 70.0919 31.3133 70.0893 31.3138Z",
    fill: "#667085",
    stroke: "#1D2939",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidatorError);
export default __webpack_public_path__ + "static/media/validator_error.0488b84ae409923c1aab4fb5e5829685.svg";
export { ForwardRef as ReactComponent };